import { parentIdDisplay } from "#/pages/provider-finder/utils/parentIdMapping"
import { defineMessage } from "react-intl"

export type GarnerProviderDisplay = Pick<parentIdDisplay, "displayName" | "combinedDisplayName">

export enum GarnerProviderType {
  OBGYN = "OBGYN",
  PEDIATRICIAN = "PEDIATRICIAN"
}

export const GARNER_PROVIDER_TYPE_MAPPPING: { [id: string]: GarnerProviderDisplay } = {
  [GarnerProviderType.OBGYN]: {
    displayName: defineMessage({ defaultMessage: "OB/GYN" }),
    combinedDisplayName: defineMessage({ defaultMessage: "OB/GYNs (for pregnancy care)" })
  },
  [GarnerProviderType.PEDIATRICIAN]: {
    displayName: defineMessage({ defaultMessage: "Pediatrician" }),
    combinedDisplayName: defineMessage({ defaultMessage: "Pediatrician" })
  }
}
